<template>
  <div class="regist">
    <div class="layout">
      <!-- 一覧 -->
      <aside class="list-pane">
        <button class="btn btn-primary block" @click="newEntry">＋ 新規商品</button>
        <input class="search" v-model="listFilter" type="text" placeholder="タイトルで検索…">
        <div class="list">
          <button
            v-for="item in filteredProducts"
            :key="item.id"
            class="list-item"
            :class="{ active: item.id === editingId }"
            @click="selectProduct(item)">
            <span class="li-title">{{ item.title }}</span>
          </button>
          <p v-if="filteredProducts.length === 0" class="empty">該当する商品がありません</p>
        </div>
      </aside>

      <!-- 入力フォーム -->
      <section class="form-pane">
        <div class="form-head">
          <h2 class="head-title">
            <span class="mode" :class="editingId ? 'mode-edit' : 'mode-new'">
              {{ editingId ? '編集中' : '新規' }}
            </span>
            商品登録
          </h2>
          <div class="actions">
            <button class="btn btn-ghost" @click="newEntry">新規</button>
            <button class="btn btn-danger" :disabled="!editingId" @click="removeEntry">削除</button>
            <button class="btn btn-primary" @click="save">保存</button>
          </div>
        </div>

        <!-- 基本情報 -->
        <div class="card">
          <div class="card-title">基本情報</div>
          <label class="field">
            <span class="label">タイトル</span>
            <input type="text" v-model="form.title" placeholder="商品名">
          </label>
          <label class="field">
            <span class="label">内容</span>
            <textarea v-model="form.content" rows="10"
              placeholder="本文。途中に画像を差し込みたい位置に gagagagazou と入力してください。"></textarea>
          </label>
        </div>

        <!-- 決済リンク -->
        <div class="card">
          <div class="card-title">決済リンク</div>
          <p class="hint">使う枠だけ入力してください。タイトルが空の枠は表示されません。</p>
          <div class="pay-slots">
            <div class="pay-slot" v-for="(pay, i) in form.pays" :key="i">
              <div class="slot-name">決済 {{ i + 1 }}</div>
              <div class="slot-fields">
                <input type="text" v-model="pay.title" placeholder="表示タイトル">
                <input type="text" v-model="pay.url" placeholder="決済URL">
              </div>
            </div>
          </div>
        </div>

        <!-- 画像 -->
        <div class="card">
          <div class="card-title">画像</div>
          <div class="grid-2">
            <div class="img-field">
              <span class="label">メイン画像</span>
              <input type="file" accept="image/*" @change="uploadImage($event, 1)">
              <div class="img-preview" v-if="form.imageurl">
                <img :src="imageUrl(form.imageurl)" alt="メイン画像">
              </div>
            </div>
            <div class="img-field">
              <span class="label">差込画像（本文の gagagagazou の位置に表示）</span>
              <input type="file" accept="image/*" @change="uploadImage($event, 2)">
              <div class="img-preview" v-if="form.imageurl2">
                <img :src="imageUrl(form.imageurl2)" alt="差込画像">
              </div>
            </div>
          </div>
        </div>

        <div class="actions actions-bottom">
          <button class="btn btn-ghost" @click="newEntry">新規</button>
          <button class="btn btn-danger" :disabled="!editingId" @click="removeEntry">削除</button>
          <button class="btn btn-primary" @click="save">保存</button>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import firebase from "../main.js";
import { collection, doc, addDoc, setDoc, getDocs, deleteDoc } from "firebase/firestore";
import { getStorage, ref, uploadBytes } from "firebase/storage";

const BUCKET = "farmy-demo.appspot.com";
const STORAGE_DIR = "products-contents-image/";
const PAY_COUNT = 10;

function emptyForm() {
  const pays = [];
  for (let i = 0; i < PAY_COUNT; i++) pays.push({ title: '', url: '' });
  return {
    title: '',
    content: '',
    imageurl: '',
    imageurl2: '',
    pays,
  };
}

export default {
  name: 'ProductsRegist',
  data() {
    return {
      products: [],
      editingId: null,
      listFilter: '',
      form: emptyForm(),
    };
  },
  computed: {
    filteredProducts() {
      const q = this.listFilter.trim().toLowerCase();
      if (!q) return this.products;
      return this.products.filter((p) => (p.title || '').toLowerCase().includes(q));
    },
  },
  mounted() {
    this.fetchProducts();
  },
  methods: {
    async fetchProducts() {
      this.products = [];
      const snap = await getDocs(collection(firebase.db, "Products"));
      snap.forEach((d) => {
        const data = d.data();
        data.id = d.id;
        this.products.push(data);
      });
    },
    newEntry() {
      this.editingId = null;
      this.form = emptyForm();
    },
    selectProduct(item) {
      this.editingId = item.id;
      const f = emptyForm();
      f.title = item.title || '';
      f.content = item.content || '';
      f.imageurl = item.imageurl || '';
      f.imageurl2 = item.imageurl2 || '';
      for (let i = 0; i < PAY_COUNT; i++) {
        f.pays[i].title = item[`title${i + 1}`] || '';
        f.pays[i].url = item[`url${i + 1}`] || '';
      }
      this.form = f;
      window.scrollTo({ top: 0, behavior: 'smooth' });
    },
    buildData() {
      const f = this.form;
      const d = {
        title: f.title,
        content: f.content,
        updateDate: new Date(),
        imageurl: f.imageurl,
        imageurl2: f.imageurl2,
      };
      for (let i = 0; i < PAY_COUNT; i++) {
        d[`title${i + 1}`] = f.pays[i].title;
        d[`url${i + 1}`] = f.pays[i].url;
      }
      return d;
    },
    async save() {
      if (!this.form.title.trim()) { alert("タイトルを入力してください"); return; }
      const data = this.buildData();
      if (this.editingId) {
        await setDoc(doc(firebase.db, "Products", this.editingId), data);
        alert("商品を更新しました");
      } else {
        data.createDate = new Date();
        await addDoc(collection(firebase.db, "Products"), data);
        alert("商品を登録しました");
      }
      await this.fetchProducts();
      this.newEntry();
    },
    async removeEntry() {
      if (!this.editingId) return;
      if (!confirm(`「${this.form.title}」を削除してもいいですか？`)) return;
      await deleteDoc(doc(firebase.db, "Products", this.editingId));
      alert("削除しました");
      await this.fetchProducts();
      this.newEntry();
    },
    imageUrl(filename) {
      if (!filename) return '';
      const path = encodeURIComponent(STORAGE_DIR + filename);
      return `https://firebasestorage.googleapis.com/v0/b/${BUCKET}/o/${path}?alt=media`;
    },
    uploadImage(event, which) {
      const file = event.target.files[0];
      if (!file) return;
      const storage = getStorage();
      const storageRef = ref(storage, STORAGE_DIR + file.name);
      uploadBytes(storageRef, file).then((snapshot) => {
        const name = snapshot.metadata.name;
        if (which === 2) this.form.imageurl2 = name;
        else this.form.imageurl = name;
      });
    },
  },
};
</script>

<style scoped>
.regist {
  --gold: #AF9453;
  --gold-dark: #937b3f;
  --danger: #c0392b;
  --border: #e3ddcd;
  --bg: #faf8f3;
  --text: #3a3630;
  color: var(--text);
  text-align: left;
  padding: 16px;
  max-width: 1200px;
  margin: 0 auto;
}
.layout { display: flex; gap: 20px; align-items: flex-start; }

/* 一覧 */
.list-pane { width: 300px; flex-shrink: 0; position: sticky; top: 12px; }
.search {
  width: 100%; margin: 10px 0; padding: 8px 10px;
  border: 1px solid var(--border); border-radius: 8px; font-size: 14px;
}
.list {
  border: 1px solid var(--border); border-radius: 10px; background: #fff;
  max-height: 70vh; overflow-y: auto;
}
.list-item {
  display: block; width: 100%; text-align: left;
  padding: 12px; border: none; border-bottom: 1px solid #f0ece1;
  background: #fff; cursor: pointer;
}
.list-item:hover { background: var(--bg); }
.list-item.active { background: #f3ecd9; box-shadow: inset 3px 0 0 var(--gold); }
.li-title { font-size: 14px; font-weight: 600; line-height: 1.3; }
.empty { padding: 16px; color: #9a927f; font-size: 13px; }

/* フォーム */
.form-pane { flex: 1; min-width: 0; }
.form-head {
  position: sticky; top: 0; z-index: 5;
  display: flex; justify-content: space-between; align-items: center;
  gap: 12px; flex-wrap: wrap;
  background: rgba(250, 248, 243, 0.95); backdrop-filter: blur(4px);
  padding: 8px 0 12px; margin-bottom: 8px; border-bottom: 1px solid var(--border);
}
.head-title { font-size: 20px; font-weight: 700; display: flex; align-items: center; gap: 10px; }
.mode { font-size: 12px; font-weight: 700; padding: 3px 10px; border-radius: 999px; }
.mode-new { background: #eef4e8; color: #4d7a2f; }
.mode-edit { background: #f3ecd9; color: var(--gold-dark); }
.actions { display: inline-flex; gap: 8px; }
.actions-bottom { justify-content: flex-end; margin-top: 16px; }

.card {
  background: #fff; border: 1px solid var(--border); border-radius: 12px;
  padding: 18px; margin-bottom: 16px;
}
.card-title {
  font-size: 15px; font-weight: 700; color: var(--gold-dark);
  margin-bottom: 14px; padding-bottom: 8px; border-bottom: 2px solid #f0ece1;
}
.hint { font-size: 12px; color: #9a927f; margin: -6px 0 12px; }

.field { display: block; margin-bottom: 14px; }
.label { display: block; font-size: 13px; font-weight: 600; margin-bottom: 5px; color: #6b6555; }
.grid-2 { display: grid; grid-template-columns: 1fr 1fr; gap: 14px; }

input[type="text"],
textarea {
  width: 100%; padding: 9px 11px; border: 1px solid var(--border);
  border-radius: 8px; font-size: 14px; font-family: inherit; background: #fff; box-sizing: border-box;
}
input:focus, textarea:focus {
  outline: none; border-color: var(--gold); box-shadow: 0 0 0 3px rgba(175, 148, 83, 0.15);
}
textarea { resize: vertical; line-height: 1.5; }

/* 決済枠 */
.pay-slots { display: flex; flex-direction: column; gap: 10px; }
.pay-slot {
  display: grid; grid-template-columns: 90px 1fr; gap: 12px; align-items: center;
  padding: 10px; background: var(--bg); border-radius: 8px;
}
.slot-name { font-size: 13px; font-weight: 700; color: #6b6555; }
.slot-fields { display: grid; grid-template-columns: 1fr 1.4fr; gap: 8px; }

/* 画像 */
.img-field { display: flex; flex-direction: column; gap: 8px; }
.img-field input[type="file"] { font-size: 13px; }
.img-preview img {
  max-width: 100%; max-height: 180px; border-radius: 8px; border: 1px solid var(--border);
}

/* ボタン */
.btn {
  padding: 9px 18px; border-radius: 8px; font-size: 14px; font-weight: 700;
  cursor: pointer; border: 1px solid transparent; transition: filter 0.15s, background 0.15s;
}
.btn.block { width: 100%; }
.btn-primary { background: var(--gold); color: #fff; }
.btn-primary:hover { filter: brightness(1.06); }
.btn-ghost { background: #fff; color: var(--gold-dark); border-color: var(--border); }
.btn-ghost:hover { background: var(--bg); }
.btn-danger { background: #fff; color: var(--danger); border-color: #e3b7b1; }
.btn-danger:hover { background: #fdeeec; }
.btn-danger:disabled { color: #c9c3b5; border-color: var(--border); cursor: not-allowed; background: #fff; }

/* レスポンシブ */
@media screen and (max-width: 860px) {
  .layout { flex-direction: column; }
  .list-pane { width: 100%; position: static; }
  .list { max-height: 260px; }
  .grid-2 { grid-template-columns: 1fr; }
  .pay-slot { grid-template-columns: 1fr; gap: 8px; }
  .slot-fields { grid-template-columns: 1fr; }
}
</style>
